
export class countClass {
  public typ;
  public ParamDoZmiany:string;
  public CoZrobic:string;
  public daneTabeli:Tabela;
  public parent:string;
 

  public init(data:countClass){ 
    // console.log("f_source", data);
    this.typ = data.typ;
    this.ParamDoZmiany = data.ParamDoZmiany;
    this.CoZrobic = data.CoZrobic;
    this.parent = data.parent;
    if(data.daneTabeli != null){
      this.daneTabeli = new Tabela();
      this.daneTabeli.ZmianaTabelaSpecjanla = data.daneTabeli.ZmianaTabelaSpecjanla;
      this.daneTabeli.zakresy = new Wiersz();
      this.daneTabeli.zakresy.init(data.daneTabeli.zakresy);
      this.daneTabeli.wiersze = [];
      data.daneTabeli.wiersze.forEach(element => {
        var w = new Wiersz();
        w.init(element);
        this.daneTabeli.wiersze.push(w);
      });
    }
   

  }
}

export class Tabela {
  public zakresy:Wiersz;
  public wartosciSzukane:Wiersz;
  public wiersze:Wiersz[];
  public ZmianaTabelaSpecjanla = false;
}
export class Wiersz {
  public wartosci:string[];
  public wynik:string;
   public init(data:Wiersz){ 
    this.wartosci = data.wartosci;
    this.wynik = data.wynik;
  }
}

